export default __webpack_public_path__ + "static/media/custom-patients-icon.9ae11d21.svg";